import Vue from 'vue'
import axios from 'axios';
import Form from './Form'
import Cart from './Cart'
import defaultFormData from './defaultFormData'
import { AgeVerify } from "./AgeVerify";
import { ShopRules } from "./ShopRules";
import { inCents, inDollars, percentageOfXInCents } from './Teller'
import VueMask from 'v-mask';
import defaultData from './defaultFormData'
Vue.use(VueMask);
Vue.config.productionTip = false;

// declare global {
//     interface Window { drivescout_config: any; }
// }

window.drivescout_config = window.drivescout_config || {};
const cart = new Cart();
const form = new Form(defaultFormData);

const drivescout = new Vue({
    components: {},
    el: '#drivescout-app',
    data() {
        return {
            menu: false,
            datepickerState: {
                date: new Date()
            },
            addToCartMessage: '',
            displayPaymentOptions: false,
            productAddedToCart: {},

            doesNotHaveLearnersPermit: false,

            error_message: null,
            success_message: null,

            form: form,
            loginForm: {
                username: "",
                password: "",
                error: {
                    title: "",
                    detail: ""
                },
                isBusy: false
            },
            cart: cart,

            shopRules: {},

            couponForm: {
                submitting: false,
                coupon_code: null,
            },

            cartUrl: window.drivescout_config.cartUrl,
            successUrl: window.drivescout_config.successUrl,
            shopUrl: window.drivescout_config.shopUrl,
            checkoutUrl: window.drivescout_config.checkoutUrl,
            loginUrl: window.drivescout_config.loginUrl,

            states: window.drivescout_config.states,

            studentHasAccount: false,
            surchargePercentage: parseFloat(window.drivescout_config.shop.info.surcharge_percentage) / 100,

            sections: {
                student_information: {
                    visible: true,
                },
                billing_information: {
                    visible: true,
                },
                payment_information: {
                    visible: true,
                }, 
                terms_of_service: {
                    visible: true
                },
                login: {
                    visible: true
                }
            },
            shop: {
                name: window.drivescout_config.shop.name,
                phone: window.drivescout_config.shop.phone,
                info: window.drivescout_config.shop.info
            },
            urls: window.drivescout_config.urls
        }
    },
    created() {
        // if (this.shop.info.hasOwnProperty('gateway_config') && this.shop.info.gateway_config['gateway'] === 'paypal') {
        //     let clientID = this.shop.info.gateway_config.client_id;
        //     let token = this.shop.info.gateway_config.client_token;

        //     const PAYPAL_SCRIPT = 'https://www.paypal.com/sdk/js?client-id=' + clientID;
        //     const script = document.createElement('script');
        //     script.setAttribute('src', PAYPAL_SCRIPT);
        //     script.setAttribute('data-client-token', token)
        //     document.head.appendChild(script);
        // }
        const rules = new ShopRules(window.drivescout_config.shop.info);
        this.shopRules = rules;
        this.cart.setShopRules(rules);
        this.cart.update();
    },
    watch: {
        doesNotHaveLearnersPermit(newValue, oldValue) {
            this.toggleLearnersPermit(newValue)
        },
        menu (val) {
            this.$refs.menu.$refs.agenda.mode = 'year';
        },
    },
    computed: {
        surchargeAmountBilled() {
            if (!this.surchargePercentage) {
                return 0;
            }

            if (this.allowsPayLater && parseInt(this.form.card.payment_amount) > 0) {
                return percentageOfXInCents(parseInt(this.form.card.payment_amount), this.shopRules.surchargePercentage());
            }

            return parseInt((this.surchargePercentage * this.cart.totalDue()).toString());
        },
        surchargeAmountBilledInDollars() {
            if (!this.surchargeAmountBilled) {
                return 0;
            }
            return inDollars(this.surchargeAmountBilled);
        },
        surchargeBilledSeparately() {
            return this.shopRules.surchargeBilledSeparately() || false;
        },
        totalDue() {
            if (!this.cart.totalDue()) {
                return 0;
            }

            return inDollars(this.cart.totalDue());
        },
        totalBilled() {

            if (this.allowsPayLater === false) {
                return inDollars(this.applySurchargeTo(this.cart.totalDue())) || 0;
            }

            if (this.allowsPayLater && parseInt(this.form.card.payment_amount) > 0) {
                return inDollars(
                    this.applySurchargeTo(
                        this.cart.applyCouponTo(
                            inCents(parseInt(this.form.card.payment_amount))
                        )
                    )
                ) || 0;
            }

            return inDollars(this.applySurchargeTo(this.cart.totalDue())) || 0;
        },
        surchargeDetail() {
            return window.drivescout_config.shop.info.surcharge_detail || '';
        },
        allowsPayLater() {
            return this.cart.allowsPayLater();
        },
        requiresDeposit() {
            return this.cart.requiresDeposit();
        },
        minimumDepositAmountRequired() {
            return this.cart.minimumDepositAmountRequired();
        }
    },

    methods: {
        async validateForm() {
            let response = true;
            await axios.post(this.shopUrl + '?action=checkout-validate', this.form.data()).then(result => {
                return response;
            }).catch(Error => {
                response = false;
            })
            return response;
        },
        addPlaceholderDataToPermit() {
            this.form.permit.permit_number = 'TBD';
            this.form.permit.issue_date = '01/01/2000';
            this.form.permit.expiration_date = '01/01/2050';
        },
        enableFullPaymentOptions() {
            delete this.form.card.payment_amount;
            this.displayPaymentOptions = true;
        },
        buyNowPayLater() {
            this.form.busy = true;
            this.form.submitting = true;
            delete this.form.card;
            delete this.form.billing_address;
            this.checkout();
        },
        toggleLearnersPermit(doesNotHavePermit) {
            if (doesNotHavePermit === true) {
                this.addPlaceholderDataToPermit()
            } else {
                this.form.permit.permit_number = '';
                this.form.permit.issue_date = '';
                this.form.permit.expiration_date = '';
            }
        },
        checkout() {
            this.success_message = null;
            this.error_message = null;
            if (this.doesNotHaveLearnersPermit === true) {
                this.addPlaceholderDataToPermit();
            }
            if (this.shopRules.cacheCompatibilityEnabled()) {
                this.form.setCacheCompatibilityEnabled(true);
                this.form.setProducts(this.cart.products());
            }
            this.form.submit('post', this.shopUrl + '?action=checkout')
                .then(response => {
                    this.cart.clear();
                    this.form.busy = false;
                    this.form.submitting = false;
                    this.form.reset();
                    window.localStorage.removeItem('dc-auth-token');
                    window.localStorage.removeItem('dc-user');
                    window.location.replace(this.successUrl);
                })
                .catch(response => {
                    this.form.busy = false;
                    this.form.submitting = false;
                    this.success_message = null;
                    this.error_message = null;
                    if (this.form.hasOwnProperty('billing_address') === false) {
                        this.form.billing_address = defaultData.billing_address;
                    }
                    for (const property in this.sections) {
                        this.sections[property].visible = true;
                    }
                    if (response.hasOwnProperty('message')) {
                        // this.error_message = response.message;
                        this.form.errors.record({ error_message : [response.message]});
                        this.form.errors.modal.open = true;
                    }
                    if (response.hasOwnProperty('detail')) {
                        // this.error_message = response.detail;
                        this.form.errors.record({ error_message : [response.detail]});
                        this.form.errors.modal.open = true;
                    }
                });
        },
        setUser(response) {
            const user = response.data.user;
            const token = response.data.access_token;
            this.form.student.access_token = token;
            this.form.student.firstname = user.firstname;
            this.form.student.lastname = user.lastname;
            this.form.student.email = user.email;
            this.form.student.phone = user.phone;
            this.form.student.dob = user.birthday;
            this.form.student.driving_experience = user.driving_experience;
            if (user.permit){
                this.form.permit.permit_number = user.permit.number;
                this.form.permit.issue_date = user.permit.issue_date;
                this.form.permit.expiration_date = user.permit.expiration_date;
            }
            if (user.home_address){
                this.form.home_address.street = user.home_address.street;
                this.form.home_address.city = user.home_address.city;
                this.form.home_address.state = user.home_address.state;
                this.form.home_address.zip = user.home_address.zip;
            }
            window.localStorage.setItem('dc-auth-token', response.data.token);
            window.localStorage.setItem('dc-user', JSON.stringify(response.data.user));
            this.loginForm.busy = false;
        },
        login(){
            this.loginForm.busy = true;
            this.loginForm.error = {
                title: "",
                detail: ""
            }
            axios.post(this.shopUrl + '?action=login', {'username' : this.loginForm.username, 'password' : this.loginForm.password}).then(response => {
                this.setUser(response);
                this.loginForm.username = "";
                this.loginForm.password = "";
            }).catch(Error => {
                this.loginForm.busy = false;
                this.loginForm.error.title = Error.response.data.title;
                this.loginForm.error.detail = Error.response.data.detail;
                if (Error.response.data.message){
                    this.loginForm.error.title = "There was an error logging in.";
                    this.loginForm.error.detail = Error.response.data.message;
                }
                //throw Error;
            })
        },
        studentAge() {
            return AgeVerify(this.form.student.dob);
        },
        addProductToCart(product_id) {
            this.cart.addProduct(product_id);
            this.addToCartMessage = 'Product added to cart successfully.';
        },
        applySurchargeTo(amount) {
            return amount + this.surchargeAmountBilled;
        }
    },

});

export default drivescout;

